<style src="./TariffPlan.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-5">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="createPlan">
              <h2>Cadastro de Planos Tarifários</h2>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  placeholder="Padrão"
                  class="form-control"
                  v-model="form.name"
                />
              </div>
              <div class="form-group">
                <label>Tolerancia Livre(minutos)</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="form.freeTolerance"
                  placeholder="5"
                />
              </div>

              <div class="form-check">
                <p class="details">
                  Ao terminar o tempo de uso dessa tarifa, ela força o
                  estacionamento do veículo utilizando a próxima regra de
                  tarifa.
                </p>
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="form.autoParkVehicle"
                />
                <label class="form-check-label checkboxlabel"
                  >Auto estacionar</label
                >
              </div>
              <div class="form-check">
                <p class="details">
                  Reseta a contagem de continuidade se a tarifa utilizada
                  anteriormente for diferente dessa.
                </p>
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="form.resetContinuityWhenChange"
                />
                <label class="form-check-label checkboxlabel"
                  >Resetar tarifa na troca de plano</label
                >
              </div>

              <h3>Exibição</h3>
              <div class="form-group">
                <label>Mostar tarifas</label>
                <select
                  class="form-control"
                  v-model="form.exhibition.enableSheet"
                >
                  <option value="false">Não</option>
                  <option value="gt">Maior</option>
                  <option value="gte">Maior ou igual</option>
                  <option value="lt">Menor</option>
                  <option value="lte">Menor ou igual</option>
                  <option value="eq">Igual</option>
                  <option value="any">Sempre</option>
                </select>
              </div>
              <div class="form-group">
                <label>Mostar botões</label>
                <select
                  class="form-control"
                  v-model="form.exhibition.enableButton"
                >
                  <option value="false">Não</option>
                  <option value="gt">Maior</option>
                  <option value="gte">Maior ou igual</option>
                  <option value="lt">Menor</option>
                  <option value="lte">Menor ou igual</option>
                  <option value="eq">Igual</option>
                  <option value="any">Sempre</option>
                </select>
              </div>
              <div class="form-group">
                <label>Mostar débitos</label>
                <select
                  class="form-control"
                  v-model="form.exhibition.enableDebitSheet"
                >
                  <option value="false">Não</option>
                  <option value="gt">Maior</option>
                  <option value="gte">Maior ou igual</option>
                  <option value="lt">Menor</option>
                  <option value="lte">Menor ou igual</option>
                  <option value="eq">Igual</option>
                  <option value="any">Sempre</option>
                </select>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="form.exhibition.justOneTime"
                />
                <label class="form-check-label checkboxlabel"
                  >Usar só uma vez no dia</label
                >
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="form.exhibition.justOneTimePerContinuous"
                />
                <label class="form-check-label checkboxlabel"
                  >Usar só uma vez na continuidade</label
                >
              </div>
              <div class="form-group">
                <label>Estado da Continuidade</label>
                <p>
                  De acordo com o estado da continuidade é possível exibir ou
                  não o botão para uso
                </p>
                <select
                  class="form-control"
                  v-model="form.exhibition.continuityState"
                >
                  <option value="0">Ambos</option>
                  <option value="1">Com continuidade</option>
                  <option value="2">Sem continuidade</option>
                </select>
              </div>

              <h4>Botões</h4>
              <div class="form-group">
                <label>Caption</label>
                <input
                  class="form-control"
                  v-model="form.exhibition.button.caption"
                  type="text"
                  placeholder="Estacionar"
                />
              </div>
              <div class="form-group">
                <label>Icon</label>
                <input
                  class="form-control"
                  v-model="form.exhibition.button.icon"
                  type="text"
                  placeholder="Estacionar"
                />
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Cor de fundo</label>
                    <input
                      class="form-control"
                      v-model="form.exhibition.button.backgroundColor"
                      type="color"
                      placeholder="Estacionar"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Cor de texto</label>
                    <input
                      class="form-control"
                      v-model="form.exhibition.button.foregroundColor"
                      type="color"
                      placeholder="Estacionar"
                    />
                  </div>
                </div>
              </div>
              <h5>Fotos</h5>
              <div>
                <table class="table table-hover table-mail">
                  <thead class="table-head">
                    <tr>
                      <th>Nome</th>
                      <th>Prefixo</th>
                      <th>Sufixo</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody class="table-list">
                    <tr
                      v-for="(photo, listIdx) in form.exhibition.button.photos"
                      :key="listIdx"
                    >
                      <td>{{ photo.name }}</td>
                      <td>{{ photo.prefix }}</td>
                      <td>{{ photo.suffix }}</td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-outline"
                          title="Remover"
                          @click="removePhoto(listIdx)"
                        >
                          <i class="fa fa-trash text-danger"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <form v-on:submit.prevent="addPhoto">
                  <div class="form-group">
                    <label>Nome</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="form.photoForm.name"
                      placeholder="Placa"
                    />
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Prefixo</label>
                        <input
                          class="form-control"
                          type="text"
                          v-model="form.photoForm.prefix"
                          placeholder="IRR"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Sufixo</label>
                        <input
                          class="form-control"
                          type="text"
                          v-model="form.photoForm.suffix"
                          placeholder="Placa"
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-block btn-primary compose-mail"
                  >
                    Adicionar a foto
                  </button>
                </form>
              </div>
              <h3>Tarifas</h3>

              <div>
                <table class="table table-hover table-mail">
                  <thead class="table-head">
                    <tr>
                      <th>Caption</th>
                      <th>Inico</th>
                      <th>Termino</th>
                      <th>Preço</th>
                      <th>Incremental</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody class="table-list">
                    <tr
                      v-for="(tariff, listIdx) in form.tariffSheet"
                      :key="listIdx"
                    >
                      <td>{{ tariff.caption }}</td>
                      <td>{{ tariff.startMinute }}</td>
                      <td>{{ tariff.endMinute }}</td>
                      <td>{{ tariff.price }}</td>
                      <td>{{ tariff.isIncremental }}</td>
                      <td class="list-command">
                        <button
                          type="button"
                          class="btn btn-outline"
                          @click="editTariffMode(listIdx)"
                        >
                          <i class="fa fa-edit text-success"></i>
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-outline"
                          title="Remover"
                          @click="removeTariff(listIdx)"
                        >
                          <i class="fa fa-trash text-danger"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <form v-on:submit.prevent="addTariff">
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>Caption</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="form.tariffSheetForm.caption"
                        placeholder="1H"
                      />
                    </div>
                    <div class="form-group col-lg-6">
                      <label>Preço</label>
                      <input
                        class="form-control"
                        type="number"
                        v-model="form.tariffSheetForm.price"
                        placeholder="250"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Inicio(minutos)</label>
                        <input
                          class="form-control"
                          type="number"
                          v-model="form.tariffSheetForm.startMinute"
                          placeholder="0"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Termino(minutos)</label>
                        <input
                          class="form-control"
                          type="number"
                          v-model="form.tariffSheetForm.endMinute"
                          placeholder="60"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      v-model="form.tariffSheetForm.isIncremental"
                    />
                    <label class="form-check-label checkboxlabel"
                      >Incremental</label
                    >
                  </div>

                  <button
                    v-if="!form.tariffSheetForm.editTariff"
                    type="submit"
                    class="btn btn-block btn-primary compose-mail"
                  >
                    Adicionar a tarifa
                  </button>
                  <div v-if="form.tariffSheetForm.editTariff">
                    <button
                      type="button"
                      class="btn btn-outline"
                      @click="cancelTariffEdition()"
                    >
                      Cancelar
                    </button>

                    <button
                      type="button"
                      class="btn btn-warning pull-right"
                      href="mail_compose.html"
                      @click="updateTariff()"
                    >
                      <i class="fa fa-save"></i>
                      Salvar Tarifa
                    </button>
                  </div>
                </form>
              </div>
              <br />
              <br />

              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                v-if="!form.control.editModeId"
              >
                <i class="fa fa-save"></i>
                Criar Plano
              </button>

              <div v-if="form.control.editModeId">
                <button
                  class="btn btn-outline"
                  href="mail_compose.html"
                  :disabled="form.control.createButtonIsDisabled"
                  @click="disableEditMode"
                >
                  Cancelar
                </button>

                <button
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  :disabled="
                    form.control.createButtonIsDisabled || !permissionUpdate
                  "
                  @click="saveEdition"
                >
                  <i class="fa fa-save"></i>
                  Salvar Plano
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-7 animated fadeInRight">
        <div class="mail-box-header">
          <h2>Lista de Planos</h2>

          <form>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="searchForm.form.name"
              />

              <div class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="searchPlans"
                  v-if="permissionRead"
                >
                  <i class="fa fa-search"></i>
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="mail-box">
          <table class="table table-hover table-mail">
            <thead class="table-head">
              <tr>
                <th>Nome</th>

                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody class="table-list">
              <tr
                :class="{ unread: listItem.accountEnabled }"
                v-for="(listItem, listIdx) in registerList.list"
                :key="listIdx"
              >
                <td>{{ listItem.name }}</td>

                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    @click="enterEditMode(listItem, listIdx)"
                    v-if="permissionUpdate"
                  >
                    <i class="fa fa-edit text-success"></i>
                  </button>
                </td>
                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    title="Excluir funcionário"
                    v-if="permissionDelete"
                    @click="removePlan(listItem)"
                  >
                    <i class="fa fa-trash text-danger"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'RegisterEmployee',
  directives: { mask },
  data() {
    return {
      form: {
        name: '',
        autoParkVehicle: false,
        resetContinuityWhenChange: false,
        freeTolerance: '',
        exhibition: {
          enableSheet: 'false',
          enableButton: 'false',
          enableDebitSheet: 'false',
          justOneTime: false,
          justOneTimePerContinuous: false,
          continuityState: 0,
          displayButtonWhenLastPlanIs: null,
          displaySheetWhenCurrentRuleIs: [],
          button: {
            caption: '',
            icon: '',
            backgroundColor: '#000000',
            foregroundColor: '#000000',
            photos: [],
          },
        },
        tariffSheet: [],
        photoForm: {
          name: '',
          prefix: '',
          suffix: '',
        },
        tariffSheetForm: {
          index: false,
          editTariff: false,
          cation: '',
          startMinute: '',
          endMinute: '',
          price: '',
          isIncremental: false,
        },
        control: {
          editModeId: false,
          createButtonIsDisabled: false,
        },
      },

      searchForm: {
        form: {
          name: '',
        },
        control: {},
      },
      registerList: {
        originalList: [],
        list: [],
        control: {},
      },
    };
  },
  computed: {
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'tariff-plan',
        'CREATE',
      );
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'tariff-plan',
        'READ',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'tariff-plan',
        'UPDATE',
      );
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'tariff-plan',
        'DELETE',
      );
    },
  },
  watch: {
    'searchForm.form.name'() {
      this.searchPlans();
    },
  },
  mounted() {
    this.listPlans();
  },
  methods: {
    // Photo
    addPhoto() {
      const photoPayload = {
        name: this.form.photoForm.name,
        prefix: this.form.photoForm.prefix,
        suffix: this.form.photoForm.suffix,
      };
      this.form.exhibition.button.photos.push(photoPayload);
      this.form.photoForm.name = '';
      this.form.photoForm.prefix = '';
      this.form.photoForm.suffix = '';
    },
    removePhoto(index) {
      const photosArray = this.form.exhibition.button.photos;
      photosArray.splice(index, 1);
      this.form.exhibition.button.photos = photosArray;
    },
    // Tariff
    removeTariff(index) {
      const tariffs = this.form.tariffSheet;
      tariffs.splice(index, 1);
      this.form.tariffSheet = tariffs;
    },
    addTariff() {
      const tariffSheetPayload = {
        caption: this.form.tariffSheetForm.caption,
        price: this.form.tariffSheetForm.price,
        startMinute: this.form.tariffSheetForm.startMinute,
        endMinute: this.form.tariffSheetForm.endMinute,
        isIncremental: this.form.tariffSheetForm.isIncremental,
      };
      this.form.tariffSheet.push(tariffSheetPayload);
      this.resetTariffForm();
    },
    editTariffMode(index) {
      this.form.tariffSheetForm.index = index;
      this.form.tariffSheetForm.editTariff = true;
      this.form.tariffSheetForm.caption = this.form.tariffSheet[index].caption;
      this.form.tariffSheetForm.price = this.form.tariffSheet[index].price;
      this.form.tariffSheetForm.startMinute = this.form.tariffSheet[
        index
      ].startMinute;
      this.form.tariffSheetForm.endMinute = this.form.tariffSheet[
        index
      ].endMinute;
      this.form.tariffSheetForm.isIncremental = this.form.tariffSheet[
        index
      ].isIncremental;
    },
    cancelTariffEdition() {
      this.resetTariffForm();
    },
    updateTariff() {
      const tariffSheetPayload = {
        caption: this.form.tariffSheetForm.caption,
        price: this.form.tariffSheetForm.price,
        startMinute: this.form.tariffSheetForm.startMinute,
        endMinute: this.form.tariffSheetForm.endMinute,
        isIncremental: this.form.tariffSheetForm.isIncremental,
      };
      const tariffs = this.form.tariffSheet;
      const index = this.form.tariffSheetForm.index;

      tariffs[index] = tariffSheetPayload;
      this.form.tariffSheet = tariffs;
      this.resetTariffForm();
    },
    resetTariffForm() {
      this.form.tariffSheetForm.index = false;
      this.form.tariffSheetForm.editTariff = false;
      this.form.tariffSheetForm.caption = '';
      this.form.tariffSheetForm.price = '';
      this.form.tariffSheetForm.startMinute = '';
      this.form.tariffSheetForm.endMinute = '';
      this.form.tariffSheetForm.isIncremental = false;
    },
    // Plan
    async listPlans() {
      if (!this.permissionRead) {
        return;
      }
      const plansList = await this.$store.dispatch('TARIFF-PLAN/LoadPlans');
      this.registerList.originalList = plansList;
      this.searchPlans();
    },
    searchPlans() {
      if (!this.permissionRead) {
        return;
      }

      const listFiltered = this.registerList.originalList.filter(item => {
        return (
          item.name
            .toUpperCase()
            .indexOf(this.searchForm.form.name.toUpperCase()) > -1
        );
      });
      this.registerList.list = listFiltered;
    },
    resetPlanForm() {
      this.form.control.editModeId = false;
      this.form.name = '';
      this.form.autoParkVehicle = false;
      this.form.resetContinuityWhenChange = false;
      this.form.freeTolerance = '';
      this.form.exhibition = {
        enableSheet: 'false',
        enableButton: 'false',
        enableDebitSheet: 'false',
        justOneTime: false,
        displayButtonWhenLastPlanIs: null,
        displaySheetWhenCurrentRuleIs: null,
        button: {
          caption: '',
          icon: '',
          backgroundColor: '#000',
          foregroundColor: '#000',
          photos: [],
        },
      };
      this.form.tariffSheet = [];
      this.form.photoForm = {
        name: '',
        prefix: '',
        suffix: '',
      };
      this.form.tariffSheetForm = {
        index: false,
        editTariff: false,
        cation: '',
        startMinute: '',
        endMinute: '',
        price: '',
        isIncremental: false,
      };
    },
    async createPlan() {
      if (!this.permissionCreate) {
        return;
      }

      const payload = {
        ...this.form,
        exhibition: this.form.exhibition,
        photoForm: undefined,
        tariffSheetForm: undefined,
        control: undefined,
      };

      try {
        await this.$store.dispatch('TARIFF-PLAN/CreatePlan', payload);
        this.listPlans();

        this.resetPlanForm();
        this.$toasted.success('Plano inserido com sucesso');
      } catch (error) {
        this.$toasted.error(error.error);
      } finally {
        this.form.control.createButtonIsDisabled = false;
      }
    },
    enterEditMode(registerItem) {
      this.form.control.editModeId = registerItem._id;
      this.form.name = registerItem.name;
      this.form.autoParkVehicle = registerItem.autoParkVehicle;
      this.form.resetContinuityWhenChange =
        registerItem.resetContinuityWhenChange;
      this.form.freeTolerance = registerItem.freeTolerance;
      this.form.exhibition = registerItem.exhibition;
      this.form.tariffSheet = registerItem.tariffSheet;
    },
    disableEditMode() {
      this.form.control.editModeId = false;
      this.form.name = '';
      this.form.autoParkVehicle = false;
      this.form.resetContinuityWhenChange = false;
      this.form.freeTolerance = '';
      this.form.exhibition = {
        enableSheet: 'false',
        enableButton: 'false',
        enableDebitSheet: 'false',
        justOneTime: false,
        displayButtonWhenLastPlanIs: null,
        displaySheetWhenCurrentRuleIs: null,
        onlyPayWhenIsActive: false,
        button: {
          caption: '',
          icon: '',
          backgroundColor: '',
          foregroundColor: '',
          photos: [],
        },
      };
      this.form.tariffSheet = [];
    },
    async saveEdition() {
      this.form.control.createButtonIsDisabled = true;

      const id = this.form.control.editModeId;
      const payload = {
        ...this.form,
        exhibition: this.form.exhibition,
        photoForm: undefined,
        tariffSheetForm: undefined,
        control: undefined,
      };

      try {
        await this.$store.dispatch('TARIFF-PLAN/UpdatePlan', {
          payload,
          id,
        });
        this.listPlans();

        this.resetPlanForm();

        this.$toasted.success('Plano salvo com sucesso');
      } catch (error) {
        this.$toasted.error(error.error);
      } finally {
        this.form.control.createButtonIsDisabled = false;
      }
    },
    async removePlan({ name, _id }) {
      if (
        confirm(`Deseja deletar o plano ${name}? Essa operação não tem volta.`)
      ) {
        try {
          const id = _id;
          await this.$store.dispatch('TARIFF-PLAN/RemovePlan', {
            id,
          });
          this.listPlans();
          this.$toasted.success('Plano removido com sucesso');
        } catch (error) {
          this.$toasted.error(error.error);
        }
      }
    },
  },
};
</script>
